// Turbo renders a `<turbo-stream>` only after `turbo:before-stream-render` has fired and the next
// repaint has passed, so neither the event nor a following animation frame sees the new DOM.
// Wrapping `event.detail.render` is the documented hook that runs at the swap itself.

// Runs `around(render, streamElement)` in place of the stream's render. `around` must call and
// await `render()`: whatever runs before it still sees the old DOM, whatever runs after it the new.
export function aroundStreamRender(event, around) {
  const render = event.detail.render
  event.detail.render = (streamElement) => around(() => render(streamElement), streamElement)
}

export function afterStreamRender(event, callback) {
  aroundStreamRender(event, async (render, streamElement) => {
    await render()
    callback(streamElement)
  })
}

// Renders a stream message and resolves once every `<turbo-stream>` in it has been applied.
// Turbo appends the message synchronously and each element dispatches `turbo:before-stream-render`
// as it connects, so a listener held only for this call sees exactly this message's streams.
export function renderStreamMessage(html) {
  const rendered = []
  const capture = (event) =>
    rendered.push(new Promise((resolve) => afterStreamRender(event, () => resolve())))
  document.addEventListener("turbo:before-stream-render", capture)
  try {
    window.Turbo.renderStreamMessage(html)
  } finally {
    document.removeEventListener("turbo:before-stream-render", capture)
  }
  return Promise.all(rendered)
}
